
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5911',
  depVersions: {
  "data-privacy-request-ui": "static-1.5911",
  "client-types": "static-1.502",
  "data-fetching-client": "static-1.10033",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8422",
  "hub-http-shared-msw-handlers": "static-1.10751",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11875",
  "I18n": "static-7.1688",
  "jasmine-runner": "static-1.6834",
  "quartz": "static-1.7554",
  "react-dlb": "static-1.92",
  "rpc-client-utils": "static-1.5051",
  "ui-components-test-utils": "static-1.6012",
  "UIComponents": "static-3.8821",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.97",
  "foundations-assets": "static-1.5274",
  "foundations-components": "static-1.8613",
  "foundations-components-test-utils": "static-1.6096",
  "foundations-theming": "static-1.4864",
  "hub-http": "static-1.6596",
  "hubspot-url-utils": "static-1.4383",
  "quartz-config": "static-1.1332",
  "quartz-core": "static-1.6773",
  "quartz-routing": "static-1.984",
  "quick-fetch": "static-1.4176",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-rhumb": "static-1.17114",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11535",
  "usage-tracker": "static-1.7698",
  "usage-tracker-anonymous": "static-1.6115",
  "usage-tracker-core": "static-1.7548",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3831",
  "quartz-webpack": "static-1.3778",
  "bend-plugin-quartz-routing": "static-1.632",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.92",
  "HeadJS": "static-2.809",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3533",
  "msw": "static-1.39",
  "msw-config": "static-1.14",
  "testing-library": "static-1.162",
  "ts-schema": "static-1.4346",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "react-utils": "static-2.5607",
  "StyleGuideUI": "static-3.511",
  "jasmine": "static-4.4696",
  "bend-plugin-chirp-manifest": "static-1.461",
  "chirp-fetch": "static-1.2286",
  "HubStyle": "static-2.12182",
  "ui-addon-draggable": "static-3.5131",
  "cssUtils": "static-1.1007",
  "hs-story-utils": "static-1.9810",
  "icons": "static-2.696",
  "react-create-root-preference": "static-1.86",
  "react-select-plus": "static-1.116",
  "react-virtualized": "static-2.110",
  "ui-images": "static-2.1266",
  "bend-plugin-foundations-components": "static-1.4882",
  "floating-ui": "static-1.66",
  "foundations-theming-specialty": "static-1.2580",
  "react-aria": "static-1.75",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2864",
  "ui-fonts": "static-1.1137",
  "foundations-components-legacy": "static-1.1638",
  "bend-plugin-foundations-theming": "static-1.3347",
  "foundations-theming-base": "static-1.3849",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.347",
  "opentelemetry-fe-types": "static-1.171",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.895",
  "hubspotter-http": "static-1.4911",
  "mobile-manifest-mixins": "static-1.590",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.546",
  "quartz-auth": "static-1.1229",
  "quartz-head": "static-1.1219",
  "quartz-i18n": "static-1.1229",
  "quartz-test": "static-1.1229",
  "quartz-tracking": "static-1.933",
  "trellis-components": "static-1.2883",
  "usage-tracker-container": "static-1.7688",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3452",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.81",
  "sassPrefix": "static-1.275",
  "stylex-utils": "static-1.155",
  "trellis-theming": "static-1.1363",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.90",
  "hubspotter-http-shared-msw-handlers": "static-1.10749",
  "usage-tracker-session-replay": "static-1.5384",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5911",
  "client-types": "/client-types/static-1.502",
  "data-fetching-client": "/data-fetching-client/static-1.10033",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8422",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10751",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11875",
  "I18n": "/I18n/static-7.1688",
  "jasmine-runner": "/jasmine-runner/static-1.6834",
  "quartz": "/quartz/static-1.7554",
  "react-dlb": "/react-dlb/static-1.92",
  "rpc-client-utils": "/rpc-client-utils/static-1.5051",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6012",
  "UIComponents": "/UIComponents/static-3.8821",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "foundations-assets": "/foundations-assets/static-1.5274",
  "foundations-components": "/foundations-components/static-1.8613",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6096",
  "foundations-theming": "/foundations-theming/static-1.4864",
  "hub-http": "/hub-http/static-1.6596",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "quartz-config": "/quartz-config/static-1.1332",
  "quartz-core": "/quartz-core/static-1.6773",
  "quartz-routing": "/quartz-routing/static-1.984",
  "quick-fetch": "/quick-fetch/static-1.4176",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-rhumb": "/react-rhumb/static-1.17114",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11535",
  "usage-tracker": "/usage-tracker/static-1.7698",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6115",
  "usage-tracker-core": "/usage-tracker-core/static-1.7548",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3831",
  "quartz-webpack": "/quartz-webpack/static-1.3778",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.632",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.92",
  "HeadJS": "/HeadJS/static-2.809",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3533",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.14",
  "testing-library": "/testing-library/static-1.162",
  "ts-schema": "/ts-schema/static-1.4346",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "react-utils": "/react-utils/static-2.5607",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "jasmine": "/jasmine/static-4.4696",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.461",
  "chirp-fetch": "/chirp-fetch/static-1.2286",
  "HubStyle": "/HubStyle/static-2.12182",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5131",
  "cssUtils": "/cssUtils/static-1.1007",
  "hs-story-utils": "/hs-story-utils/static-1.9810",
  "icons": "/icons/static-2.696",
  "react-create-root-preference": "/react-create-root-preference/static-1.86",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-virtualized": "/react-virtualized/static-2.110",
  "ui-images": "/ui-images/static-2.1266",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4882",
  "floating-ui": "/floating-ui/static-1.66",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2580",
  "react-aria": "/react-aria/static-1.75",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2864",
  "ui-fonts": "/ui-fonts/static-1.1137",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1638",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3347",
  "foundations-theming-base": "/foundations-theming-base/static-1.3849",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.347",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.171",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.895",
  "hubspotter-http": "/hubspotter-http/static-1.4911",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.590",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.546",
  "quartz-auth": "/quartz-auth/static-1.1229",
  "quartz-head": "/quartz-head/static-1.1219",
  "quartz-i18n": "/quartz-i18n/static-1.1229",
  "quartz-test": "/quartz-test/static-1.1229",
  "quartz-tracking": "/quartz-tracking/static-1.933",
  "trellis-components": "/trellis-components/static-1.2883",
  "usage-tracker-container": "/usage-tracker-container/static-1.7688",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.81",
  "sassPrefix": "/sassPrefix/static-1.275",
  "stylex-utils": "/stylex-utils/static-1.155",
  "trellis-theming": "/trellis-theming/static-1.1363",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.90",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10749",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5384",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
